var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.stack.length
    ? _c(
        "div",
        { attrs: { "data-component": "app-toast-container" } },
        [
          _c(
            "transition-group",
            { staticClass: "toasts", attrs: { name: "toasts", tag: "div" } },
            _vm._l(_vm.stack, function (toast) {
              return _c(
                "div",
                {
                  key: toast.id,
                  staticClass: "toast",
                  class: _vm.getToastClass(toast),
                },
                [
                  _c("div", { staticClass: "content" }, [
                    _vm.getIcon(toast)
                      ? _c("div", { staticClass: "icon" }, [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.getIcon(toast)) +
                              "\n        "
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "text" }, [
                      _vm._v(
                        "\n          " + _vm._s(toast.message) + "\n        "
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        attrs: { "data-button": "clear" },
                        on: {
                          click: function ($event) {
                            return _vm.onCloseToast(toast.id)
                          },
                        },
                      },
                      [_c("or-icon", { attrs: { icon: "close" } })],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  toast.details
                    ? _c(
                        "span",
                        {
                          attrs: { "data-button": "toggle-details" },
                          on: {
                            click: function ($event) {
                              return _vm.toggleToastDetails(toast)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.getExpandButtonLabel(toast)) +
                              "\n      "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  toast.isExpanded
                    ? _c("div", {
                        staticClass: "details",
                        domProps: {
                          innerHTML: _vm._s(_vm.getToastDetailsAsText(toast)),
                        },
                      })
                    : _vm._e(),
                ]
              )
            }),
            0
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }